import findIndex from 'lodash/findIndex'
import isNil from 'lodash/isNil'
import isEmpty from 'lodash/isEmpty'
import reduce from 'lodash/reduce'
import { FormErrors, formValueSelector as getFormValueSelector, getFormInitialValues as getGetFormInitialValues } from 'redux-form'
import { translate as mainTranslate } from 'loankeeper-common/helpers'
import { FORM_NAME } from './constants'

import { ProductDetailsServerData } from '@lk/api'

export const round = (value: number) => Math.round(value * 100) / 100

export const translateWebMessages = (key: string): string => mainTranslate(`frm_web_messages-${key}`)

export const translate = (key: string): string => mainTranslate(`frm_app_add_edit-${key}`)

export const translateBic = (key: string): string => mainTranslate(`frm_bic_wizard-${key}`)

export const translateV = (key: string): string => mainTranslate(`frm_application_view-${key}`)

export const translateClientSearch = (key: string): string => mainTranslate('frm_client_list', key)

export const translateLKMessage = (key: string): string => mainTranslate('LKMESSAGE', key)

export const getSearchPanelConfig = (productViewDetail: ProductDetailsServerData) => {
  const { ClientTypeCheck, ClientType } = productViewDetail

  const searchPanelConfig = {
    initialValues: {
      safety: {
        blacklisted: 2,
      },
      categ: {}
    },
    fieldsDisability: {
      categ: {
        individuals: true,
        solidarityGroups: true,
        companies: true,
      },
      safety: {
        blacklisted: true,
      },
    },

    hintAboveMessage: translateClientSearch('lbl_healthy_only'),
  }

  if (ClientTypeCheck === 1) {
    searchPanelConfig.initialValues = {
      ...searchPanelConfig.initialValues,
      categ: {
        individuals: findIndex(ClientType, (next) => next.ID === 1) !== -1,
        solidarityGroups: findIndex(ClientType, (next) => next.ID === 2) !== -1,
        companies: findIndex(ClientType, (next) => next.ID === 3) !== -1,
      },
    }
  } else {
    searchPanelConfig.initialValues = {
      ...searchPanelConfig.initialValues,
      categ: {
        individuals: true,
        solidarityGroups: true,
        companies: true,
      },
    }
  }
  return searchPanelConfig
}

export const formValueSelector = getFormValueSelector(FORM_NAME)

//@ts-ignore
export const getFormInitialValues = (...args) => getGetFormInitialValues(FORM_NAME)(...args)
//@ts-ignore
export const withFallbackReturnValue = (fn, fallbackValue, isValid = (...args) => !isNil(...args)) => (...args) => {
  const returnValue = fn(...args)
  return isValid(returnValue) ? returnValue : fallbackValue
}

export const arrayToMapByKey = <T>(arr: Array<T>, key: string): {[x: number] : T} => reduce(arr, (acc, curr) => ({ ...acc, [curr[key]]: curr }), {})

export const isSyncErrorsHelper = (syncErrors: any) => !isEmpty(syncErrors)

export const isAsyncErrorsHelper = (asyncErrors: any) => !isEmpty(asyncErrors)

export const isSubmitErrorsHelper = (submitErrors: any) => !isEmpty(submitErrors)

export const isFormErrorHelper = (formError: any) => !isNil(formError)
